import React from "react"
import {
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Media,
  Button,
  Badge,
} from "reactstrap"
import PerfectScrollbar from "react-perfect-scrollbar"
import axios from "axios"
import * as Icon from "react-feather"
import classnames from "classnames"
import Autocomplete from "../../../components/@vuexy/autoComplete/AutoCompleteComponent"
import { history } from "../../../history"
import { commonpostApiFunction } from "../../../resources/ApiController"
import jwt from 'jsonwebtoken'
import Avatar from "../../../components/@vuexy/avatar/AvatarComponent"

const logout = e => {
  //let isCaseID = JSON.parse(localStorage.getItem('CaseData'));
  let isUserID = JSON.parse(localStorage.getItem('gensysuserloginObject'));
  // if(isCaseID!==null){
  // let params = {
  //   "caseId": isCaseID.CaseNumberDetailID,
  //   "userId": isUserID.UserDetailID,
  //   "token":(localStorage.getItem('gensysuserJWTToken')).replace(/['"]+/g, ''),
  // }
  // commonpostApiFunction('releaseCaseNumberLockStatus', params, setcasenumberunlock, 'onError') 
  // }
  let params = {
    "userId": isUserID.UserDetailID,
    "token": (localStorage.getItem('gensysuserJWTToken')).replace(/['"]+/g, ''),
  }
  commonpostApiFunction('releaseLoggedOutUserLockStatus', params, setcasenumberunlock, 'onError')
  // localStorage.removeItem('CaseData');
  localStorage.removeItem('gensysuserloginObject');
  // eslint-disable-next-line no-restricted-globals
  location.href = '/login';
}



const setcasenumberunlock = (response) => {

  if (response.data.success === '1') {
    //this.setState({});
  } else {
    //this.setState({});
  }
}

const UserDropdown = props => {
  return (
    // <DropdownMenu right>
    <DropdownMenu end>
      {/* <DropdownItem tag="a" href="#">
        <Icon.User size={14} className="mr-50" />
        <span className="align-middle">Edit Profile</span>
      </DropdownItem> */}
      {/* <DropdownItem tag="a" href="#">
        <Icon.Mail size={14} className="mr-50" />
        <span className="align-middle">My Inbox</span>
      </DropdownItem> */}
      {/* <DropdownItem tag="a" href="#">
        <Icon.CheckSquare size={14} className="mr-50" />
        <span className="align-middle">Tasks</span>
      </DropdownItem> */}
      {/* <DropdownItem tag="a" href="#">
        <Icon.MessageSquare size={14} className="mr-50" />
        <span className="align-middle">Chats</span>
      </DropdownItem> */}
      {/* <DropdownItem tag="a" href="#">
        <Icon.Heart size={14} className="mr-50" />
        <span className="align-middle">WishList</span>
      </DropdownItem> */}
      <DropdownItem tag="a" href="/changepassword">
        <Icon.Key size={14} className="mr-50" />
        <span className="align-middle">Change Password</span>
      </DropdownItem>
      <DropdownItem divider />
      <DropdownItem tag="a" href="#" onClick={e => logout()}>
        <Icon.Power size={14} className="mr-50" />
        <span className="align-middle">Log Out</span>
      </DropdownItem>
    </DropdownMenu>
  )
}

class NavbarUser extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      navbarSearch: false,
      suggestions: [],
      username: '',
      userData: [],
      decodedToken: [],
      isSessionTimedOut: 0,
      jwtToken: [],
      isExpired: false,
    }
    // this.logout=this.logout.bind(this)
  }

  componentDidMount() {
    axios.get("/api/main-search/data").then(({ data }) => {
      this.setState({ suggestions: data.searchResult })
    })

    this.verifyLoginObject();
    if (this.state.userData && !this.state.isExpired) {

      let username = this.state.userData.UserName;
      let rgx = new RegExp(/(\p{L}{1})\p{L}+/, 'gu');

      let initials = [...username.matchAll(rgx)] || [];

      initials = (
        (initials.shift()?.[1] || '') + (initials.pop()?.[1] || '')
      ).toUpperCase();

      this.setState({
        username: this.state.userData.UserName,
        initials: initials
      })
    }

    // this.state.userData=JSON.parse(localStorage.getItem('gensysuserloginObject'))
    // if(this.state.userData!=null)
    // {
    //     this.setState({username:this.state.userData.UserName})
    // }
  }



  verifyLoginObject = () => {
    this.state.userData = JSON.parse(localStorage.getItem('gensysuserloginObject'))
    this.state.jwtToken = JSON.parse(localStorage.getItem('gensysuserJWTToken'))
    if (!this.state.userData) {
      //this.state.redirect='/login'
      this.setState({ redirect: '/login' })
    } else {
      this.verifyJWTToken();
    }
  }

  verifyJWTToken = () => {
    this.state.decodedToken = jwt.decode(this.state.jwtToken, { complete: true })
    let dateNow = new Date()
    if (this.state.jwtToken) {
      if (this.state.decodedToken.payload.exp < Math.floor(dateNow.getTime() / 1000)) {
        this.state.isExpired = true
      }
    }
    else {
      this.state.isExpired = true
    }
    if (this.state.isExpired) {
      this.state.isSessionTimedOut = 1
      localStorage.setItem("isgensysuserSessionTimedOut", this.state.isSessionTimedOut)
      localStorage.removeItem('gensysuserJWTToken')
      localStorage.removeItem('gensysuserloginObject')
      this.state.userData = null
      this.setState({ redirect: '/login' })
    }
  }


  handleNavbarSearch = () => {
    this.setState({
      navbarSearch: !this.state.navbarSearch
    })
  }



  render() {
    return (
      <ul className="nav navbar-nav navbar-nav-user float-right">


        <UncontrolledDropdown
          tag="li"
          className="dropdown-notification nav-item"
        >
          {/* <DropdownToggle tag="a" className="nav-link nav-link-label">
            <Icon.Bell size={21} />
            <Badge pill color="primary" className="badge-up">
              {" "}
              5{" "}
            </Badge>
          </DropdownToggle> */}
          {/* <DropdownMenu tag="ul" right className="dropdown-menu-media"> */}
          <DropdownMenu tag="ul" end className="dropdown-menu-media">
            <li className="dropdown-menu-header">
              <div className="dropdown-header mt-0">
                <h3 className="text-white">5 New</h3>
                <span className="notification-title">App Notifications</span>
              </div>
            </li>
            <PerfectScrollbar
              className="media-list overflow-hidden position-relative"
              options={{
                wheelPropagation: false
              }}
            >
              <div className="d-flex justify-content-between">
                <Media className="d-flex align-items-start">
                  <Media left href="#">
                    <Icon.PlusSquare
                      className="font-medium-5 primary"
                      size={21}
                    />
                  </Media>
                  <Media body>
                    <Media heading className="primary media-heading" tag="h6">
                      You have new order!
                    </Media>
                    <p className="notification-text">
                      Are your going to meet me tonight?
                    </p>
                  </Media>
                  <small>
                    <time
                      className="media-meta"
                      dateTime="2015-06-11T18:29:20+08:00"
                    >
                      9 hours ago
                    </time>
                  </small>
                </Media>
              </div>
              <div className="d-flex justify-content-between">
                <Media className="d-flex align-items-start">
                  <Media left href="#">
                    <Icon.DownloadCloud
                      className="font-medium-5 success"
                      size={21}
                    />
                  </Media>
                  <Media body>
                    <Media heading className="success media-heading" tag="h6">
                      99% Server load
                    </Media>
                    <p className="notification-text">
                      You got new order of goods?
                    </p>
                  </Media>
                  <small>
                    <time
                      className="media-meta"
                      dateTime="2015-06-11T18:29:20+08:00"
                    >
                      5 hours ago
                    </time>
                  </small>
                </Media>
              </div>
              <div className="d-flex justify-content-between">
                <Media className="d-flex align-items-start">
                  <Media left href="#">
                    <Icon.AlertTriangle
                      className="font-medium-5 danger"
                      size={21}
                    />
                  </Media>
                  <Media body>
                    <Media heading className="danger media-heading" tag="h6">
                      Warning Notification
                    </Media>
                    <p className="notification-text">
                      Server has used 99% of CPU
                    </p>
                  </Media>
                  <small>
                    <time
                      className="media-meta"
                      dateTime="2015-06-11T18:29:20+08:00"
                    >
                      Today
                    </time>
                  </small>
                </Media>
              </div>
              <div className="d-flex justify-content-between">
                <Media className="d-flex align-items-start">
                  <Media left href="#">
                    <Icon.CheckCircle
                      className="font-medium-5 info"
                      size={21}
                    />
                  </Media>
                  <Media body>
                    <Media heading className="info media-heading" tag="h6">
                      Complete the task
                    </Media>
                    <p className="notification-text">
                      One of your task is pending.
                    </p>
                  </Media>
                  <small>
                    <time
                      className="media-meta"
                      dateTime="2015-06-11T18:29:20+08:00"
                    >
                      Last week
                    </time>
                  </small>
                </Media>
              </div>
              <div className="d-flex justify-content-between">
                <Media className="d-flex align-items-start">
                  <Media left href="#">
                    <Icon.File className="font-medium-5 warning" size={21} />
                  </Media>
                  <Media body>
                    <Media heading className="warning media-heading" tag="h6">
                      Generate monthly report
                    </Media>
                    <p className="notification-text">
                      Reminder to generate monthly report
                    </p>
                  </Media>
                  <small>
                    <time
                      className="media-meta"
                      dateTime="2015-06-11T18:29:20+08:00"
                    >
                      Last month
                    </time>
                  </small>
                </Media>
              </div>
            </PerfectScrollbar>
            <li className="dropdown-menu-footer">
              <DropdownItem tag="a" className="p-1 text-center">
                <span className="align-middle">Read all notifications</span>
              </DropdownItem>
            </li>
          </DropdownMenu>
        </UncontrolledDropdown>
        <UncontrolledDropdown tag="li" className="dropdown-user nav-item">
         
          <UserDropdown {...this.props} />
        </UncontrolledDropdown>
      </ul>
    )
  }
}
export default NavbarUser
